import clearSortingTemplate from './clearSorting.html';

export function clearSortingDirective() {
    return {
        restrict: 'E',
        templateUrl: clearSortingTemplate,
        scope: {
            parentController: '='
        }
    };
}
